module.exports = __webpack_public_path__ + "img/maeshiro-sensei-large.e09675ed.jpg";